import React from "react";
import { useState, useEffect } from "react";
import authStorage from "../service/authStorage";
import { useNavigate } from "react-router-dom";
import UsersDataTable from "../components/UsersDataTable";
import { Link } from "react-router-dom";
import {
  UserContext,
  UserContextProvider,
} from "../components/users/UserContext";
import { useContext } from "react";
import Logo from "../components/mainPage/Logo";

const Users = () => {
  const USERS_URL = process.env.REACT_APP_ARI_URL + "/users";
  const [isNeedRefreshUsers, setIsNeedRefreshUsers] = useState(false);
  const BEARER = authStorage();
  const [errorMsg, setErrorMsg] = useState();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const user = useContext(UserContext);

  // refresh users data from server
  useEffect(() => {
    setErrorMsg("");
    const fetchItems = async () => {
      try {
        const response = await fetch(`${USERS_URL}`, {
          headers: {
            Authorization: BEARER,
          },
        });
        if (response.status === 401) {
          navigate("/login");
        }
        const data = await response.json();
        setItems(data);
      } catch (err) {
        setErrorMsg("Server in not responding");
      }
    };
    setIsNeedRefreshUsers(false);
    fetchItems();
  }, [isNeedRefreshUsers]);

  return (
    <div className="main-page-graphAndTree">
      <div className="item tree">
        <div className="logo-background">
          <Logo />
        </div>
        <div className="folders-panel"></div>
        <div className="left-link-space">
          <Link to="/logout">
            <button className="small-button red">LOGOUT</button>
          </Link>
          <Link to="/account-info">
            <button className="small-button deep-blue">USER INFO</button>
          </Link>
          <Link to="/">
            <button className="small-button deep-blue">SCENARIOS</button>
          </Link>
        </div>
        <div className="item graph">
          <div className="users">
            <h4>USERS</h4>
            <UsersDataTable
              items={items}
              setIsNeedRefreshUsers={setIsNeedRefreshUsers}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
